import { setJPushID } from './localStorage'

const debug = process.env.NODE_ENV !== 'production'

export const initPushServices = () => {
  if ('JPush' in window) {
    console.log('initialize JPush...')
    try {
      window.JPush.init()
      window.JPush.setDebugMode(debug)
      if (device.platform !== 'Android') {
        window.JPush.setApplicationIconBadgeNumber(0)
      }
    } catch (exception) {
      console.log(exception)
    }
  } else {
    console.error('JPush is not exist...')
  }
}

export const handleRegistrationID = () => {
  if ('JPush' in window) {
    window.JPush.getRegistrationID((data) => {
      setJPushID(data)
    })
  }
}

export const addShopTags = (shopTags) => {
  if ('JPush' in window) {
    let sequenceNo = 1
    let tags = Array.from(shopTags, tag => 'm' + tag)
    window.JPush.addTags({ sequence: sequenceNo++, tags: tags },
      (result) => {
        // var sequence = result.sequence
        // var tags = result.tags
        // success(sequence, tags)
        console.log('Tresult:', result)
      }, (error) => {
        console.log(error)
      })
  }
}

export const cleanShopTags = () => {
  if ('JPush' in window) {
    window.JPush.cleanTags({ sequence: 1 },
      (result) => {
        // var sequence = result.sequence
      }, (error) => {
        console.log(error)
      })
  }
}
export const addUserAlias = (userAlias) => {
  if ('JPush' in window) {
    let sequenceNo = 1
    let ualias = 'u' + userAlias
    window.JPush.setAlias({ sequence: sequenceNo++, alias: ualias },
      (result) => {
        // var sequence = result.sequence
        // var tags = result.tags
        // success(sequence, tags)
        console.log('Aresult:', result)
      }, (error) => {
        console.log(error)
      })
  }
}

export const cleanUserAlias = () => {
  if ('JPush' in window) {
    window.JPush.deleteAlias({ sequence: 1 },
      (result) => {
        // var sequence = result.sequence
      }, (error) => {
        console.log(error)
      })
  }
}

export const cleanJPushAll = () => {
  this.cleanShopTags()
  this.cleanUserAlias()
}



// WEBPACK FOOTER //
// ./src/assets/js/pushServices.js